import {
    Dimensions,
    getDimensionsConstrainedToContainer,
    getDimensionsConstrainedToContainerWidth,
} from '@99designs/browser';
import { ZoomLevel } from './zoomLevel';

export function getAvailableZoomLevels(
    fileDimensions: Dimensions | null,
    containerDimensions: Dimensions | null
) {
    const zoomLevels: ZoomLevel[] = [];

    if (
        !fileDimensions ||
        !fileDimensions.height ||
        !fileDimensions.width ||
        !containerDimensions ||
        !containerDimensions.height ||
        !containerDimensions.width
    ) {
        return zoomLevels;
    }

    if (canFitToContainer(fileDimensions, containerDimensions)) {
        zoomLevels.push(ZoomLevel.FIT_TO_CONTAINER);
    }

    if (canFitToWidth(fileDimensions, containerDimensions)) {
        if (
            !isEqualDimensions(
                getDimensionsConstrainedToContainerWidth(fileDimensions, containerDimensions),
                getDimensionsConstrainedToContainer(fileDimensions, containerDimensions)
            )
        ) {
            zoomLevels.push(ZoomLevel.FIT_TO_WIDTH);
        }
    }

    zoomLevels.push(ZoomLevel.FIT_TO_NATIVE);
    return zoomLevels;
}

export function canFitToContainer(fileDimensions: Dimensions, containerDimensions: Dimensions) {
    return !(
        fileDimensions.width < containerDimensions.width &&
        fileDimensions.height < containerDimensions.height
    );
}

export function canFitToWidth(fileDimensions: Dimensions, containerDimensions: Dimensions) {
    return (
        fileDimensions.width > containerDimensions.width &&
        fileDimensions.height > containerDimensions.height
    );
}

export function isEqualDimensions(a: Dimensions, b: Dimensions) {
    return a.width === b.width && a.height === b.height;
}

export const getDefaultZoomLevel = (availableZoomLevels: ZoomLevel[]) => {
    if (availableZoomLevels.indexOf(ZoomLevel.FIT_TO_CONTAINER) > -1) {
        return ZoomLevel.FIT_TO_CONTAINER;
    } else if (availableZoomLevels.indexOf(ZoomLevel.FIT_TO_NATIVE) > -1) {
        return ZoomLevel.FIT_TO_NATIVE;
    } else {
        return ZoomLevel.FLUID;
    }
};

export const getNextZoomLevel = (availableZoomLevels: ZoomLevel[], zoomLevel: ZoomLevel) => {
    const index = availableZoomLevels.indexOf(zoomLevel);
    const nextIndex = index + 1;
    return availableZoomLevels[nextIndex] ? availableZoomLevels[nextIndex] : null;
};

export const getPrevZoomLevel = (availableZoomLevels: ZoomLevel[], zoomLevel: ZoomLevel) => {
    const index = availableZoomLevels.indexOf(zoomLevel);
    const prevIndex = index - 1;
    return availableZoomLevels[prevIndex] ? availableZoomLevels[prevIndex] : null;
};

export const getZoomLevel = (targetZoomLevel: ZoomLevel, availableZoomLevels: ZoomLevel[]) => {
    const isInValidTargetZoom = availableZoomLevels.indexOf(targetZoomLevel) === -1;

    return isInValidTargetZoom ? getDefaultZoomLevel(availableZoomLevels) : targetZoomLevel;
};
